// GA4 analytics service (#501). Single wrapper around gtag so components never
// touch window.gtag directly, and tracking silently no-ops when gtag is absent
// (adblockers, consent-blocked, SSR-ish contexts).
//
// gtag itself is loaded in public/index.html (G-1T64KZC0HM). SPA page_views are
// sent from router.afterEach in main.js — if GA4's Enhanced Measurement
// "page changes based on browser history" is enabled on the property, DISABLE
// either that setting or TRACK_SPA_PAGEVIEWS below, otherwise every navigation
// double-counts.

export const TRACK_SPA_PAGEVIEWS = true;

function gtagSafe(...args) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  try {
    window.gtag(...args);
    return true;
  } catch (e) {
    // Never let analytics break the app.
    console.warn('[analytics] gtag call failed', e);
    return false;
  }
}

/** SPA navigation page_view. Call from router.afterEach. */
export function trackPage(path, title) {
  if (!TRACK_SPA_PAGEVIEWS) return;
  gtagSafe('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
}

/**
 * Business event. `params` values should be primitives; undefined/null entries
 * are stripped so GA4 doesn't receive empty dimensions.
 *
 * Events in use (#501): view_ad, filter_search, visit_request,
 * contact_designer_request, videocall_open, videocall_request, ad_like,
 * ad_mode_switch, ad_daynight_switch, ad_furniture_switch, ad_style_select,
 * ad_plan_view, ad_gallery_nav, configure_open, login, contact_phone_click,
 * contact_email_click, renovation_quote_start, ping_create, share (method =
 * native|copy|whatsapp|facebook|email). Ad-scoped events
 * carry ad_id (+ agency_id where available); filter_search / ping_create carry
 * city + tipologia; funnel-entry events carry source. Registered event-scoped
 * custom dimensions in GA4: ad_id, agency_id, city, mode, style, tipologia
 * (`source` is sent but not yet registered as a dimension).
 */
export function trackEvent(name, params = {}) {
  const clean = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== '') clean[k] = v;
  }
  gtagSafe('event', name, clean);
}
